import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { APIError, get } from '../services/crud'
import { IServiceTax, IServiceTaxSearchResponse } from './typings'
import { ENTITY_TYPES } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.taxRate}`
export const getLeadOppServiceTax = createAsyncThunk<
  IServiceTax,
  { entityId: number; entityType: ENTITY_TYPES },
  { rejectValue: APIError }
>('taxRate', async ({ entityId, entityType }, thunkApi) => {
  const path = entityType === ENTITY_TYPES.Lead ? 'lead' : 'opportunity'
  const response = await get(`${baseUrl}/${path}/${entityId}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
export const getLocationTaxDetails = createAsyncThunk<
  IServiceTax,
  { entityId: number; entityType: ENTITY_TYPES; locationId: number },
  { rejectValue: APIError }
>(
  'lead/locationDetails',
  async ({ entityId, entityType, locationId }, thunkApi) => {
    const path = entityType === ENTITY_TYPES.Lead ? '/Lead' : '/Opportunity'
    const response = await get(
      `${ServiceConfig.baseAPIUrl}${path}/GetLocationDetails/${entityId}?locationId=${locationId}`,
    )
    if (response.ok) return await response.json()
    return thunkApi.rejectWithValue(await response.json())
  },
)

export const getLocationServiceTax = createAsyncThunk<
  IServiceTax,
  string,
  { rejectValue: APIError }
>('taxRate/location', async (locationId, thunkApi) => {
  const response = await get(`${baseUrl}/location/${locationId}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})

export const getTaxRates = createAsyncThunk<
  IServiceTaxSearchResponse,
  void,
  { rejectValue: APIError }
>('taxRates', async (_, thunkApi) => {
  const response = await get(`${baseUrl}`)

  const data = await response.json()

  if (response.ok) return data

  return thunkApi.rejectWithValue({ status: response.status, ...data })
})
